export class BusinessSubscription {
  public businessId: number;
  public businessName: string;
  public subscriptionId: number;
  public subscriptionType: string;
}
